import { render, staticRenderFns } from "./review_file.vue?vue&type=template&id=284effec"
import script from "./review_file.vue?vue&type=script&lang=js"
export * from "./review_file.vue?vue&type=script&lang=js"
import style0 from "./review_file.vue?vue&type=style&index=0&id=284effec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports